module.exports = "/_next/static/images/IlloUseCaseBoostCrossSellDefault-37a46829a56fa921b7ee6b90ee71ac3a.png";